import type {
  AmbientHeidiTriggeredProps,
  AmbientHeidiUtteranceLifecycleProps,
} from '@heidi/agents/contracts';
import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';
import {
  type ProcessLifecycle,
  trackAmbientHeidiTriggeredSpec,
  trackProcessLifecycleSpec,
} from '@snowtype/snowplow';

import { TrackingEventName } from '@/models/analytics/eventTypes';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

// Ambient payloads are allowlisted field by field: a schema-invalid payload is
// stored whole as a failed event, so an unexpected prop must never reach it.
// The clip is hand-rolled at 1-2-0, which pins the capture shapes, until Snowtype
// is regenerated against it; the generated ProcessLifecycle spec is still 1-1-0.
export const ambientEvents: SnowplowEventMap = {
  [TrackingEventName.AmbientHeidiTriggered]: (props) => {
    const { trigger_id, outcome } = props as AmbientHeidiTriggeredProps;
    trackAmbientHeidiTriggeredSpec({ trigger_id, outcome });
  },
  [TrackingEventName.ProcessLifecycle]: (props) => {
    const lifecycle = props as ProcessLifecycle | AmbientHeidiUtteranceLifecycleProps;
    if (lifecycle.process_type !== 'ambient_utterance_capture') {
      trackProcessLifecycleSpec(lifecycle as ProcessLifecycle);
      return;
    }
    const {
      process_type,
      process_status,
      result_type,
      entity_type,
      entity_id,
      duration_ms,
      error_type,
    } = lifecycle as AmbientHeidiUtteranceLifecycleProps;
    const data: AmbientHeidiUtteranceLifecycleProps = {
      process_type,
      process_status,
      result_type,
      entity_type,
      entity_id,
      duration_ms,
      error_type,
    };
    trackSelfDescribingEvent({
      event: { schema: 'iglu:com.heidi/process_lifecycle/jsonschema/1-2-0', data },
    });
  },
};
